import styled from 'styled-components';
import { MediaQuery, NeutralColors, PurpleColors } from 'theme';

const Container = styled.div`
  flex: 1;
  min-width: 0;
  padding: 12px 24px;
  overflow: auto;
  max-height: calc(100vh - 240px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 804px;
  width: 100%;
  margin: auto;

  @media (max-width: ${MediaQuery.screenSizes.desktop - 1}px) {
    max-height: calc(100vh - 180px);
  }

  .x-markdown table {
    display: table;
    width: max-content;
    max-width: none;
    overflow: visible;
    border-collapse: separate;
    border-spacing: 12px 0px;
    padding-bottom: 12px;

    td {
      border-bottom: 1px solid ${NeutralColors[20]};
    }

    tr:last-child {
      td {
        border-bottom: none;
      }
    }
  }
`;

const TableWrapper = styled.div`
  max-width: 100%;
  overflow-x: auto;
`;

const AudioBubbleContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const AudioBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  color: ${PurpleColors[70]};

  svg {
    width: 14px;
    height: 14px;
  }

  svg path {
    fill: ${PurpleColors[70]};
  }
`;

export { AudioBadge, AudioBubbleContent, Container, TableWrapper };
